import { useEffect, useState } from "react";
import { API, Endpoints } from "@brg/api";

type PlayerOrMatchType = "player" | "match" | null;

export const useGetPlayerOrMatchProject = (
    id: string,
    type: PlayerOrMatchType,
    enabled: boolean,
) => {
    const [project, setProject] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<boolean | number>(false);

    useEffect(() => {
        if (!enabled || !id || !type) {
            return;
        }

        setIsLoading(true);
        API.request()
            .endpoint(Endpoints.geograffee)
            .url(`/api/project/${type}/${id}`)
            .send()
            .then((r) => {
                if (r.status !== 200) {
                    setError(r.status);
                }
                return r.json();
            })
            .then((r) => {
                setIsLoading(false);
                setProject(r);
            })
            .catch(() => {
                setIsLoading(false);
                setError(true);
            });
    }, [id, type, enabled]);

    return { project, isLoading, error };
};
import { useEffect, useState } from "react";
import { API, Endpoints } from "@brg/api";

type PlayerOrMatchType = "player" | "match" | null;

export const useGetPlayerOrMatchProject = (
    id: string,
    type: PlayerOrMatchType,
    enabled: boolean,
) => {
    const [project, setProject] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<boolean | number>(false);

    useEffect(() => {
        if (!enabled || !id || !type) {
            return;
        }

        setIsLoading(true);
        API.request()
            .endpoint(Endpoints.geograffee)
            .url(`/api/project/${type}/${id}`)
            .send()
            .then((r) => {
                if (r.status !== 200) {
                    setError(r.status);
                }
                return r.json();
            })
            .then((r) => {
                setIsLoading(false);
                setProject(r);
            })
            .catch(() => {
                setIsLoading(false);
                setError(true);
            });
    }, [id, type, enabled]);

    return { project, isLoading, error };
};
